// ---------------------------------------------------------------------------
// Canonical stage definitions
// ---------------------------------------------------------------------------
export const CANONICAL_STAGES = [
    'import',
    'form-recognition',
    'batch-fix',
    'ocr',
    'post-ocr',
    'key-entry',
    'verification',
    'qa',
    'supervisor',
    'pre-export',
    'export',
];
/** All stages that appear in a Profile's stage list (batch-fix is system-managed, not configurable). */
export const PROFILE_CONFIGURABLE_STAGES = CANONICAL_STAGES.filter((s) => s !== 'batch-fix');
/** Stages that are always enabled in every profile and cannot be disabled. */
export const REQUIRED_STAGES = [
    'import',
    'ocr',
    'post-ocr',
    'key-entry',
    'verification',
    'pre-export',
    'export',
];
// ---------------------------------------------------------------------------
// Guard helpers
// ---------------------------------------------------------------------------
export function isProfileConfigurableStage(s) {
    return PROFILE_CONFIGURABLE_STAGES.includes(s);
}
export function isRequiredStage(s) {
    return REQUIRED_STAGES.includes(s);
}
// ---------------------------------------------------------------------------
// Factory functions
// ---------------------------------------------------------------------------
export function createDefaultRecognitionConfig() {
    return {
        hints: [],
        sampleTemplates: [],
        confidenceThreshold: 0.75,
        multiFormBatchPolicy: 'allow',
    };
}
/**
 * Creates a non-fallback profile with:
 * - required stages enabled
 * - optional configurable stages disabled
 * - batch-fix excluded entirely
 */
export function createDefaultProfile(id, name) {
    const stages = PROFILE_CONFIGURABLE_STAGES.map(stage => ({
        stage,
        enabled: isRequiredStage(stage),
        config: {},
    }));
    return {
        id,
        name,
        isFallback: false,
        predicate: { clauses: [], combinator: 'all' },
        stages,
    };
}
/**
 * Creates a fallback profile with all configurable stages enabled.
 * batch-fix is excluded.
 */
export function createFallbackProfile(id, name = 'Default') {
    const stages = PROFILE_CONFIGURABLE_STAGES.map(stage => ({
        stage,
        enabled: true,
        config: {},
    }));
    return {
        id,
        name,
        isFallback: true,
        predicate: { clauses: [], combinator: 'all' },
        stages,
    };
}
//# sourceMappingURL=profiles.js.map